import {
  CommonModule,
  CurrencyPipe,
  APP_BASE_HREF,
  TitleCasePipe
} from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, UrlSerializer } from '@angular/router';
import { TrailingSlashUrlSerializer } from '@core/trailing-slash-url.serializer';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { environment } from '../environments/environment';
import { ProjectRouting } from './app-routing.module';
import { AppComponent } from './app.component';
import { ErrorInterceptor } from './core/error.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpService } from './core/http.service';
import { NgxStripeModule } from 'ngx-stripe';
import { ModalModule } from 'ngx-bootstrap/modal';
import { StoreModule } from '@ngrx/store';
import { UserProfileReducer } from './modules/shared/user-profile.reducer';
import { cacheReducer } from './modules/shared/store/cache.reducer';
import { apiCacheReducer } from './core/cache/api-cache.reducer';
import { SharedModule } from './modules/shared/shared.module';
import { AuthInterceptor } from './core/auth-int.interceptor';
import { provideFirebaseApp, initializeApp, getApp } from '@angular/fire/app';
import { provideMessaging, getMessaging } from '@angular/fire/messaging';
import {
  provideRemoteConfig,
  getRemoteConfig
} from '@angular/fire/remote-config';
import { HistoryService } from './core/routing-history.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { WINDOW, windowProvider } from './core/window.token';
import { CacheService } from '@shared/services/cache.service';
import { MinimizedPlayerComponent } from '@components/minimized-player/minimized-player.component';
import { DevToolbarComponent } from '@components/dev-toolbar/dev-toolbar.component';

const devOnlyImports = environment.production ? [] : [DevToolbarComponent];

@NgModule({
  declarations: [AppComponent],
  imports: [
    MinimizedPlayerComponent,
    ...devOnlyImports,
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    HttpClientModule,
    CommonModule,
    RouterModule,
    BrowserAnimationsModule,
    ProjectRouting,
    ModalModule.forRoot(),
    ToastrModule.forRoot(environment.toastrConfig),
    StoreModule.forRoot({
      userProfile: UserProfileReducer,
      refreshKeys: UserProfileReducer,
      otherUserProfile: UserProfileReducer,
      cache: cacheReducer,
      apiCache: apiCacheReducer
    },
    {
      runtimeChecks: {
        strictStateImmutability: false,
        strictActionImmutability: false,
      }
    }),
    NgxStripeModule.forRoot(environment.stripeConfig.key),
    SharedModule,
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideMessaging(() => getMessaging()),
    provideRemoteConfig(() => getRemoteConfig(getApp())),
    ServiceWorkerModule.register('offline.service.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  exports: [SharedModule],
  providers: [
    HttpService,
    NgbActiveModal,
    windowProvider,
    { provide: WINDOW, useExisting: WINDOW },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: UrlSerializer, useClass: TrailingSlashUrlSerializer },
    CurrencyPipe,
    TitleCasePipe,
    HistoryService,
    CacheService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule {}
